import React from 'react';
import gql from 'graphql-tag';
import { base64EncodeProductId } from './cart_helpers';

export const collectionProductsQuery = (handle) => gql`
	query collectionQuery {
		collectionByHandle(handle: "${handle}") {
			id
			description
			title
			handle
			products(first: 10) {
				edges {
					node {
						availableForSale
						descriptionHtml
						handle
						id 
						images(first: 50) {
						  pageInfo {
						    hasNextPage
						    hasPreviousPage
						  }
						  edges {
						    node {
						      altText
						      thumbnailImg:transformedSrc(maxWidth: 300, maxHeight: 300, crop:CENTER)
						      productImg:transformedSrc(maxWidth: 960, maxHeight: 1220, crop:CENTER)
						      
						    }
						  }
						}
						variants(first: 100) {
						  pageInfo {
						    hasNextPage
						    hasPreviousPage
						  }
						  edges {
						    node {
						      id
						      title
						      price
						      compareAtPrice
						      available
									availableForSale
									presentmentPrices(first:5) {
										edges {
											node {
												compareAtPrice {
													amount
													currencyCode
												}
												price {
													amount
													currencyCode
												}
											}
										}
									}
						      selectedOptions {
						        name
						        value
						      }
						      image {
						        altText
						        thumbnailImg:transformedSrc(maxWidth: 300, maxHeight: 300, crop:CENTER)
						        productImg:transformedSrc(maxWidth: 960, maxHeight: 1220, crop:CENTER)
						      }
						    }
						  }
						}
					}
				}
			}
		}
	}
`


export const boldProductsQuery = () => gql`
  fragment ProductFragment on Product {
      id
      handle
			variants(first: 100) {
				edges {
					node {
						id
						title
						price
						compareAtPrice
						available
						availableForSale
						presentmentPrices(first:5) {
							edges {
								node {
									compareAtPrice {
										amount
										currencyCode
									}
									price {
										amount
										currencyCode
									}
								}
							}
						}
					}
				}
			}
    }
    query productsQuery($ids: [ID!]!) {
      nodes(ids: $ids) {
        ...ProductFragment
      }
    }
`



// const cart = {}


// cart.productQuery = (productTitle) => `
//   query {
//     shop {
//       products(query: "${productTitle}", first: 250) {
//         edges{
//           node {
//             id
//             collections(first: 100){
//               edges{
//                 node{
//                   handle
//                 }
//               }
//             }
//           }
//         }
//       }  
//     }
//   }
// `;




// cart.apiSettings  = (productTitle) => {
//     return {
//     'async': true,
//     'crossDomain': true,
//     'method': 'POST',
//     'headers': {
//         'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
//         'Content-Type': 'application/graphql',
//     },
//     'body': cart.productQuery(productTitle)
//     };
// }

// fetch(GRAPHQL_URL, cart.apiSettings(item.product_title))

